import { useForgotPasswordMutation } from "@sso/apis/resetPassword";
import { useGetUserById } from "@sso/apis/users/hooks";
import { DialogTitle, notificationsMsgs } from "@sso/constant";
import { useAppSelector } from "@sso/hooks/useRedux";
import { selectDialog } from "@sso/store/slices/dialog";
import { Typography } from "@sso/ui/Typography";

import { DialogActionButtons, DialogBody, DialogHeader } from "../components";

export const UserResetPasswordDialog = () => {
  const { id } = useAppSelector(selectDialog);
  const user = useGetUserById(id as string);

  const [sendResetPasswordLink, { isLoading }] = useForgotPasswordMutation();

  const handleDeleteAction = () => {
    if (!id || !user) {
      return;
    }
    sendResetPasswordLink({ email: user.email, successMessage: notificationsMsgs.USER_RESET_PASSWORD });
  };

  return (
    <>
      <DialogHeader title={DialogTitle.USER_RESET_PASSWORD} />
      <DialogBody>
        <Typography display="initial">
          Are you sure to reset the password for this User?
          <br />
          <br />
          <small>{user ? `Name: ${user.fullName}` : "Error finding the user"}</small>
        </Typography>
      </DialogBody>
      <DialogActionButtons loading={isLoading} buttonTitle={"Reset"} onClickAction={handleDeleteAction} />
    </>
  );
};
